import React from "react";
import { motion } from "framer-motion";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import SC from "./style";
import theme from "../../theme";

const Footer = () => {
  const handleLinkdin = () => {
    window.open("https://www.linkedin.com/company/prakalpa-ai");
  };
  const handleFaecbook = () => {
    window.open("https://www.facebook.com/PrakalpaAI");
  };
  const handleTwiter = () => {
    window.open("https://x.com/Prakalpa_ai");
  };
  return (
    <>
      {/* BottomSection */}
      <SC.BottomSection>
        <SC.BottomSectionChild>
          <span style={{ fontSize: "0.9rem" }}>
            ©2026 Prakalpa. All rights reserved.
          </span>

          <div
            style={{
              display: "flex",
              gap: "8px",
              color: theme.colors.text.tertiary,
            }}
          >
            <SC.NavLinkBottom
              style={{ color: theme.colors.text.tertiary }}
              href="termsandconditions"
            >
              <span>Terms & Conditions</span>
            </SC.NavLinkBottom>
            <SC.NavLinkBottom
              style={{ color: theme.colors.text.tertiary }}
              href="privacypolicy"
            >
              | <span>Privacy Policy</span>
            </SC.NavLinkBottom>
            <SC.NavLinkBottom
              style={{ color: theme.colors.text.tertiary }}
              href="https://prakalpa.ai/Prakalpa_Brochure.pdf"
              target="_blank"
            >
              | <span>Brochure</span>
            </SC.NavLinkBottom>
          </div>
          <SC.NavlinkContainer style={{ marginTop: "8px" }}>
            <SC.SocialLinks>
              <motion.a
                whileHover={{ scale: 1.2 }}
                onClick={() => handleFaecbook()}
              >
                <FacebookIcon
                  size={20}
                  sx={{ color: theme.colors.text.primary, cursor: "pointer" }}
                />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.2 }}
                onClick={() => handleTwiter()}
              >
                <XIcon
                  sx={{
                    fontSize: "20px",
                    color: theme.colors.text.primary,
                    cursor: "pointer",
                  }}
                />
              </motion.a>
              <motion.a whileHover={{ scale: 1.2 }}>
                <LinkedInIcon
                  size={20}
                  onClick={() => handleLinkdin()}
                  style={{
                    color: theme.colors.text.primary,
                    cursor: "pointer",
                  }}
                />
              </motion.a>
            </SC.SocialLinks>
          </SC.NavlinkContainer>
        </SC.BottomSectionChild>
      </SC.BottomSection>
    </>
  );
};

export default Footer;
